import { LIST_GC_TIME_MS, LIST_STALE_TIME_MS, useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { SpaceWithSites } from '@klareospace/pharos-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { createSpaceApi, spaceKeys } from '../api';

// ─── Options ──────────────────────────────────────────────────────────────────

export interface UseSpacesWithSitesOptions {
  enabled?: boolean;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useSpacesWithSites(options: UseSpacesWithSitesOptions = {}): UseQueryResult<SpaceWithSites[]> {
  const { enabled = true } = options;
  const client = useApiClient('admin-auth');
  const api = createSpaceApi(client);

  return useQuery({
    enabled,
    gcTime: LIST_GC_TIME_MS,
    queryFn: () => api.getSpacesWithSites(),
    queryKey: spaceKeys.withSites(),
    staleTime: LIST_STALE_TIME_MS,
  });
}
